var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"alert alert-danger\">\n<strong>\n<i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\nError\n</strong>\nYou don&rsquo;t have permission to access this page.\n</div>\n";
var id1="app/security/access-denied.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;